export const getTradeOptions = (tradeList) =>
  (tradeList || []).length > 0 ? (tradeList || []).map((t) => getTradeOption(t)) : null;

export const getTradeOption = (trade) => ({
  value: trade.tradeId,
  label: trade.title,
});
